import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { NavBar } from 'components/NavBar/NavBar'
import { NoData } from 'components/NoData'
import { PageWrapper } from 'styling/GlobalStyles'
import { OtherText } from 'styling/Typography'
import { RootState } from 'store'
import { IOpsTodayQuickLink } from 'types/opsToday.interface'
import { useOpsBootstrap } from 'hooks/useOpsBootstrap'
import { EnvironStrip } from './EnvironStrip'
import { TodaySwitcher } from './TodaySwitcher'
import { SiteRequestsSummary } from './TodayRequests'
import { FooterChip, FooterRow, TodayTitle } from './OpsToday.styled'

const QUICK_LINKS: IOpsTodayQuickLink[] = [
  { label: 'Full timeline', path: '/operations/timeline' },
  { label: 'My departments', path: '/operations/department' },
  { label: 'Handover report', path: '/operations/handover' },
  { label: 'Overview', path: '/operations/overview' },
]

const ACTIVE_STATUSES = ['open', 'acknowledged', 'in_progress']

export const OpsToday = () => {
  const navigate = useNavigate()
  useOpsBootstrap()
  const environ = useSelector((s: RootState) => s.opsEnviron.environ)
  const requests = useSelector((s: RootState) => s.opsRequests.requests)
  const environLoading = useSelector((s: RootState) => s.opsEnviron.isLoading)
  const requestsLoading = useSelector((s: RootState) => s.opsRequests.isLoading)

  const activeRequests = useMemo(
    () => requests.filter((r) => ACTIVE_STATUSES.includes(r.status)),
    [requests],
  )

  const hasContent = Boolean(environ) || activeRequests.length > 0
  const bootstrapDone = !environLoading && !requestsLoading

  return (
    <>
      <NavBar />
      <PageWrapper>
        <TodayTitle>Today</TodayTitle>
        <OtherText grey>Day Shift · 06:00–18:00</OtherText>
        <TodaySwitcher activeKey='site' />
        {hasContent ? (
          <>
            <EnvironStrip />
            <SiteRequestsSummary />
          </>
        ) : bootstrapDone ? (
          <NoData text='Nothing scheduled for today yet. Raise a cross-department request or check the timeline for site activity.' />
        ) : null}
        <FooterRow>
          {QUICK_LINKS.map((link) => (
            <FooterChip key={link.path} onClick={() => navigate(link.path)}>
              {link.label}
            </FooterChip>
          ))}
        </FooterRow>
      </PageWrapper>
    </>
  )
}
